/**
 * @generated SignedSource<<16b9a256d6d6cabd950fb3216ff181b7>>
 * @relayHash 8bea7f69d1d006afece60d96d664e762
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 8bea7f69d1d006afece60d96d664e762

import { ConcreteRequest } from 'relay-runtime';
export type Country = "CH" | "DE";
export type de_BetterDocRecommendationState = "ADMISSION_FAILED" | "ADMITTED" | "ADMITTING" | "MEDIC_CONFIRMED" | "MEDIC_SELECTED" | "NO_SERVICE" | "PENDING" | "RECOMMENDED" | "REJECTED" | "RESEARCHING" | "RESEARCH_FAILED" | "SERVICE_TRIAGE_FAILED" | "TRIAGING";
export type de_BetterDocRemoteRequestStatus = "INVALID_RECOMMENDATION_ID" | "NOT_FOUND" | "RECEIVED" | "REQUEST_FAILED" | "UNEXPECTED_RESPONSE";
export type betterDocSelectedRecommendationsQuery$variables = {
  insuranceCountry: Country;
};
export type betterDocSelectedRecommendationsQuery$data = {
  readonly de_betterDocSelectedRecommendations: {
    readonly errorReason: string | null;
    readonly exchangeId: number | null;
    readonly httpStatusCode: number | null;
    readonly recommendations: ReadonlyArray<{
      readonly localSessionId: number | null;
      readonly medics: ReadonlyArray<{
        readonly selectionId: number | null;
      }>;
      readonly partnerPatientId: string | null;
      readonly partnerSessionId: string | null;
      readonly recommendationId: string | null;
      readonly selectedMedic: {
        readonly name: string | null;
      } | null;
      readonly selectionId: number | null;
      readonly selectionType: string | null;
      readonly state: de_BetterDocRecommendationState | null;
      readonly version: number | null;
    }>;
    readonly status: de_BetterDocRemoteRequestStatus;
  };
};
export type betterDocSelectedRecommendationsQuery = {
  response: betterDocSelectedRecommendationsQuery$data;
  variables: betterDocSelectedRecommendationsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "insuranceCountry"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "selectionId",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "insuranceCountry",
        "variableName": "insuranceCountry"
      }
    ],
    "concreteType": "de_BetterDocOpenRecommendationsResult",
    "kind": "LinkedField",
    "name": "de_betterDocSelectedRecommendations",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "status",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "httpStatusCode",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "errorReason",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "exchangeId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "de_BetterDocOpenRecommendation",
        "kind": "LinkedField",
        "name": "recommendations",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "recommendationId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "state",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "version",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "partnerPatientId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "partnerSessionId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "localSessionId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "selectionType",
            "storageKey": null
          },
          (v1/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "de_BetterDocRemoteMedic",
            "kind": "LinkedField",
            "name": "medics",
            "plural": true,
            "selections": [
              (v1/*:: as any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "de_BetterDocRemoteMedic",
            "kind": "LinkedField",
            "name": "selectedMedic",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "betterDocSelectedRecommendationsQuery",
    "selections": (v2/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "betterDocSelectedRecommendationsQuery",
    "selections": (v2/*:: as any*/)
  },
  "params": {
    "id": "8bea7f69d1d006afece60d96d664e762",
    "metadata": {},
    "name": "betterDocSelectedRecommendationsQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "3d27d77915f9611a9787fe7ebde8279c";

export default node;
